// Achievement badge utilities for fasting milestones
// Uses 7-day intervals with natural earth-tone colors

export const ACHIEVEMENT_LEVELS = [
  { days: 0, name: 'Seedling', color: 'bg-stone-400', textColor: 'text-stone-400', description: 'Just getting started' },
  { days: 7, name: 'Sprout', color: 'bg-lime-500', textColor: 'text-lime-600', description: 'First week complete!' },
  { days: 14, name: 'Sapling', color: 'bg-green-500', textColor: 'text-green-600', description: 'Two weeks strong' },
  { days: 21, name: 'Young Tree', color: 'bg-emerald-500', textColor: 'text-emerald-600', description: 'Three weeks of growth' },
  { days: 28, name: 'Oak', color: 'bg-teal-600', textColor: 'text-teal-600', description: 'A month of dedication' },
  { days: 35, name: 'Elder Oak', color: 'bg-cyan-600', textColor: 'text-cyan-600', description: 'Five weeks achieved' },
  { days: 42, name: 'Ancient', color: 'bg-sky-600', textColor: 'text-sky-600', description: 'Six weeks of wisdom' },
  { days: 49, name: 'Sage', color: 'bg-indigo-500', textColor: 'text-indigo-500', description: 'Seven weeks, truly dedicated' },
  { days: 56, name: 'Elder Sage', color: 'bg-violet-500', textColor: 'text-violet-500', description: 'Eight weeks of mastery' },
  { days: 70, name: 'Guardian', color: 'bg-purple-600', textColor: 'text-purple-600', description: 'Ten weeks, a true guardian' },
  { days: 100, name: 'Legend', color: 'bg-amber-500', textColor: 'text-amber-500', description: '100 days of fasting!' },
];

export const getAchievementLevel = (daysFasted) => {
  // Find the highest level the user has achieved
  let currentLevel = ACHIEVEMENT_LEVELS[0];
  
  for (const level of ACHIEVEMENT_LEVELS) {
    if (daysFasted >= level.days) {
      currentLevel = level;
    } else {
      break;
    }
  }
  
  return currentLevel;
};

export const getNextAchievement = (daysFasted) => {
  for (const level of ACHIEVEMENT_LEVELS) {
    if (daysFasted < level.days) {
      return {
        ...level,
        daysRemaining: level.days - daysFasted
      };
    }
  }
  return null; // Already at max level
};

export const getBadgeColor = (daysFasted) => {
  const level = getAchievementLevel(daysFasted);
  return level.color;
};

export const getBadgeTextColor = (daysFasted) => {
  const level = getAchievementLevel(daysFasted);
  return level.textColor;
};
